import { configureStore } from "@reduxjs/toolkit";
import { PermissionDataSlice } from "./Slices/PermissionSlice";


export const store = configureStore({
    reducer: {
        permissionData: PermissionDataSlice.reducer
    }
})